import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
.brand-logo {
  text-align: center;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {

    public community_link: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.session.role == 'admin') this.community_link = '/admin/community';
        else this.community_link = `/admin/community/${this.service.auth.session.community_id}/info`;
        await this.service.render();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.navbar.toggle(true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-gray-50 p-2 text-sm font-normal leading-6 text-indigo-600";
        }
        return "group flex gap-x-3 rounded-md p-2 text-sm font-normal leading-6 text-gray-700 hover:bg-gray-50 hover:text-indigo-600";
    }

    public hasAuth(roles: string) {
        roles = roles.split(",");
        return roles.includes(this.service.auth.session.role);
    }
}

export default ComponentNavSidebarComponent;